/* eslint-disable */
import { permissionsMessages } from '@ringcentral-integration/commons/enums/permissionsMessages';
export default {
  [permissionsMessages.callingDisable]:
    'U hebt onvoldoende machtigingen om uitgaande oproepen te plaatsen. Neem contact op met uw {brand}-accountbeheerder voor een upgrade.',
} as const;

// @key: @#@"[permissionsMessages.callingDisable]"@#@ @source: @#@"You don't have permissions to place outbound calls. Please contact your {brand} account administrator for an upgrade."@#@
